<template>
  <v-dialog v-model="dialog" max-width="1200">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="green" dark v-bind="attrs" v-on="on">
        新增 <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-container class="px-3 my-container">
      <!-- <v-card-title class="headline">编辑</v-card-title> -->

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>新增拆迁公司</h1></v-card-title>

        <!-- ['10001','潘金云','330421196904152048','40','缪家村','西窑洞浜１３号'], -->
        <!-- <v-divider class="mx-4 my-10"></v-divider> -->
        <v-alert
          :value="alert"
          color="red"
          dark
          border="top"
          icon="mdi-bell"
          transition="scale-transition"
        >
          {{ alert_text }}
        </v-alert>
        <v-row>
          <v-text-field
            v-model="temp.name"
            color="yellow darken-3"
            label="公司名称"
            :rules="[rules.required]"
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          
        </v-row>
        <v-row>

          <v-textarea
            v-model="temp.remark"
            color="yellow darken-3"
            label="负责区域"
            required
            class="mx-6"
            style="width:400px"
          ></v-textarea>
          
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelAddDialog">取消</v-btn>
          <v-btn color="primary" @click="confirmAddDialog">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
</template>

<script>
import { createCompany } from "@/api/companies";
// import { ModelListSelect } from "vue-search-select";
export default {
  name: "AddCompanyDialog",
  components: {},

  data: () => ({
    rules: {
        required: value => !!value || 'Field is required',
      },
    objectItem: {},
    stringItem: "",
    dialog: false,
    temp: {
      name: "",
      remark: "",
    },
    alert: false,
    alert_text: "",
  }),
  mounted() {},
  methods: {
    confirmAddDialog() {
      const tempData = this.temp;
      if (tempData['name'] == ''){
        this.alert_text = "请输入公司名称！";
        this.alert = true;
        return false;
      }
      if (tempData['remark'] == ''){
        this.alert_text = "请输入负责区域！";
        this.alert = true;
        return false;
      }
      console.log(tempData);
      createCompany(tempData).then(() => {
        this.dialog = false;
        this.temp = {};
        this.$parent.getList();
      });
    },

    cancelAddDialog() {
      this.dialog = false;
      this.temp = {};
    }
  }
};
</script>

<style scoped>
.my-container {
  background-color: rgba(90, 90, 90, 0.9);
}
</style>
